import { useHistory, useParams } from 'react-router-dom';
import { Alert, AlertTitle, Box, Link, Typography } from '@mui/material';

import { useStyles } from './subscription-inactive-banner.styles';

export default function SubscriptionInactiveBanner() {
  const classes = useStyles();
  const history = useHistory();

  const { portalId } = useParams<Record<string, string>>();

  return (
    <Box className={classes.bannerContainer}>
      <Alert severity="warning">
        <AlertTitle>Inactive Subscription</AlertTitle>
        All features are currently paused because your subscription is no longer active. Click{' '}
        <Typography style={{ display: 'inline', textDecoration: 'underline', cursor: 'pointer' }}>
          <Link onClick={() => history.push(`/home/${portalId}/subscription-pricing-table`)}>
            here
          </Link>
        </Typography>{' '}
        to revive your subscription.
      </Alert>
    </Box>
  );
}
